import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent {
  @Input() title: string = 'Ocurrió un error';
  @Input() message: string = 'Ha ocurrido un problema al procesar su solicitud.';
  @Input() code: string | number = '';
  @Input() showRetry: boolean = false;
  @Output() retry = new EventEmitter<void>();

  constructor(private router: Router) { }

  goHome() {
    this.router.navigate(['']);
  }

  onRetry() {
    this.retry.emit();
  }
}
